
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UIButton from "@/components/button/ui-button.vue";
  import storage from "@/services/storage";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class DownloadResume extends Vue {
    @Prop({ type: String, default: undefined }) resumeName?: string;

    downloadFile(): void {
      storage.get(this.resumeName!)
        .then((filePath) => {
          if (typeof filePath === "string") {
            window.open(filePath, "_self");
            return;
          }
          throw new Error("File not found");
        })
        .catch((e: Error) => {
          this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
        });
    }
  }
